import React from 'react';

const Graph_Google = () => {
    return (
        <div>Graph_Google Component</div>
    );
}

export default Graph_Google;
